module.exports = __webpack_public_path__ + "assets/img/thumb-LJ-Hooker-Video.da5fdbfe.webp";